export default __webpack_public_path__ + "static/media/mobile_scrn.df86c382.png";